import { Component, OnInit } from '@angular/core';
import { TrosakDokumentStavka } from './trosak-dokument-stavka';
import { BaseUpdateComponent, BaseDataService, ModalService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { Validators } from '@angular/forms';
import { OrgJed } from 'src/app/lookups/orgjed/orgjed';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-trosak-dokument-stavka-update',
  templateUrl: './trosak-dokument-stavka-update.component.html'
})
export class TrosakDokumentStavkaUpdateComponent
 extends BaseUpdateComponent<TrosakDokumentStavka> implements OnInit {

  orgJedItems = [];

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService,modalService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('VrstaTroskaID', Validators.required, 'required', 'TROSAKDOKUMENTSTAVKA.VRSTATROSKA.VALIDATION.REQUIRED');
    this.addValidatorToFc('OrgJedID', Validators.required, 'required', 'TROSAKDOKUMENTSTAVKA.ORGJED.VALIDATION.REQUIRED');
    // this.addValidatorToFc('Iznos', Validators.required, 'required', 'TROSAKDOKUMENTSTAVKA.IZNOS.VALIDATION.REQUIRED');
    //this.addValidatorToFc('Iznos',Validators.min(0.001),'min','TROSAKDOKUMENTSTAVKA.IZNOS.VALIDATION.MIN');
    
    this.IDProcessed
    .subscribe(value => { 
      if (value)
        if (this.Item.ID == -1 && this.Parameters != undefined) {
           this.baseDataService.Get("orgjed","getParentAndChildByParentID",null,OrgJed,null)
            .subscribe((data)=>{
              this.orgJedItems = data;
              if (this.orgJedItems.length == 1)
                this.baseFormGroup.patchValue({ OrgJedID : Number(this.orgJedItems[0]["ID"]) });
                this.baseFormGroup.get('OrgJedID').updateValueAndValidity();
            })
        }
    })

  }



 
  editMode:boolean=false;
  SaveMaster(qq){}
  Cancel(){}

}
